import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgIcon, SvgIconComponent } from '@web/shared/ui';

@Component({
  selector: 'app-header-icon',
  imports: [SvgIconComponent],
  templateUrl: './header-icon.component.html',
  styleUrl: './header-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderIconComponent {
  public readonly icon = input.required<SvgIcon>();
}
